module.exports = __webpack_public_path__ + "static/review-f96f7d289f10e1496020f76e4ea071bf.svg";